import { Grid as MantineGrid } from "@mantine/core";

export const Grid = MantineGrid;
